import React, { useState, useEffect } from 'react'
import 'animate.css'
import { Row, Col } from 'antd'
import { Link, Element, Events, scrollSpy } from 'react-scroll'

import { httpClient } from 'core/util/httpClient'
import { cooperative } from 'core/schemas'

import ScrollUpBtn from 'components/ScrollUpBtn'
import ListImage from 'components/ListImage'

import Coop from 'assets/images/png/Pic-01-Coop.png'
import InterCoop from 'assets/images/png/Pic-02-InterCoop.png'
import checklist from 'assets/images/svg/checklist.svg'

import {
  Container,
  Title,
  ContainerCooper,
  TextSection,
  TextHead,
  TextDetail,
  TextBottom,
  CardImage,
  ContainerCard,
} from './cooperative.style'

const Cooperative = () => {
  const [cooperData, setCooperData] = useState({})

  useEffect(() => {
    Events.scrollEvent.register('begin', function (to, element) {
      // console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function (to, element) {
      // console.log('end', arguments)
    })

    scrollSpy.update()

    return () => {
      Events.scrollEvent.remove('begin')
      Events.scrollEvent.remove('end')
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
    
    getDataCooper()
  }, [])

  const getDataCooper = async () => {
    const response = await httpClient.get(cooperative)

    if (response?.data?.code === 200) {
      const data = response?.data?.data

      setCooperData(data?.section)
    } else {
      setCooperData({})
    }
  }

  return (
    <>
      <Container>
        <Row className='row-title'>
          <Col span={24}>
            <Title className='animate__animated animate__flipInX animate__slow'>
              การปฏิบัติงานสหกิจศึกษา
            </Title>
          </Col>
        </Row>
        <Row className='row-section'>
          <Col span={12}>
            <Link
              activeClass='active'
              to='cooper'
              spy={true}
              smooth={true}
              duration={500}
              offset={-130}
            >
              <TextSection>สหกิจศึกษา</TextSection>
            </Link>
          </Col>
          <Col span={12}>
            <Link
              activeClass='active'
              to='inter-cooper'
              spy={true}
              smooth={true}
              duration={500}
              offset={-130}
            >
              <TextSection>สหกิจศึกษานานาชาติ</TextSection>
            </Link>
          </Col>
        </Row>

        {cooperData.length >= 0 &&
          cooperData.map((item, index) => {
            return (
              <Element
                key={index}
                name={item?.title === 'สหกิจศึกษา' ? 'cooper' : 'inter-cooper'}
              >
                <ContainerCooper
                  bg={item?.title === 'สหกิจศึกษา' ? '#FFF9EA' : '#FFF'}
                >
                  <Row>
                    <Col span={14}>
                      <TextHead>{item?.title}</TextHead>
                      <TextDetail>{item?.conent_0}</TextDetail>

                      {item?.conent_1 && (
                        <ListImage
                          listText={item?.conent_1}
                          type='list'
                          image={checklist}
                        />
                      )}

                      {item?.conent_2 && (
                        <ListImage
                          listText={item?.conent_2}
                          type='list'
                          image={checklist}
                        />
                      )}

                      {item?.conent_3 && (
                        <ListImage
                          listText={item?.conent_3}
                          type='list'
                          image={checklist}
                        />
                      )}

                      {item?.title === 'สหกิจศึกษา' ? (
                        <>
                          {item?.conent_4 && (
                            <ListImage
                              listText={item?.conent_4}
                              type='list'
                              image={checklist}
                            />
                          )}
                          {item?.conent_5 && (
                            <ListImage
                              listText={item?.conent_5}
                              type='list'
                              image={checklist}
                            />
                          )}
                          {item?.conent_6 && (
                            <ListImage
                              listText={item?.conent_6}
                              type='list'
                              image={checklist}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {item?.conent_4 && item?.conent_5 ? (
                            <ListImage
                              noteText={`${item?.conent_4}${item?.conent_5}`}
                              type='note'
                              image={checklist}
                            />
                          ) : (
                            <ListImage noteText={item?.conent_4} type='note' />
                          )}
                        </>
                      )}
                    </Col>
                    <Col span={9} offset={1}>
                      <ContainerCard>
                        <CardImage>
                          <div
                            className='hover01'
                            style={{
                              backgroundImage: `url(${item?.media}), url(${
                                item?.title === 'สหกิจศึกษา' ? Coop : InterCoop
                              })`,
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: 'cover',
                              borderRadius: '20px',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              marginTop: '20px',
                            }}
                          >
                            {item?.title === 'สหกิจศึกษา' ? (
                              <TextBottom>
                                SUT
                                <br />
                                Cooperative
                                <br />
                                Education
                              </TextBottom>
                            ) : (
                              <TextBottom>Inter Coop</TextBottom>
                            )}
                          </div>
                        </CardImage>
                      </ContainerCard>
                    </Col>
                  </Row>
                </ContainerCooper>
              </Element>
            )
          })}
      </Container>

      <ScrollUpBtn />
    </>
  )
}

export default Cooperative
